export const commerceAPIConfig = {
  proxyPath: '/mobify/proxy/api',
  parameters: {
    clientId: process.configs?.COMMERCE_API_CLIENT_ID,
    organizationId: process.configs?.COMMERCE_API_ORGANIZATION_ID,
    shortCode: process.configs?.COMMERCE_API_SHORT_CODE,
    siteId: process.configs?.COMMERCE_API_SITE_ID,

    // DEMO SITE CONFIGS
    // clientId: 'c9c45bfd-0ed3-4aa2-9971-40f88962b836',
    // organizationId: 'f_ecom_zzrf_001',
    // shortCode: 'kv7kzm78',
    // siteId: 'RefArch',
  },
};

export const contentfulAPIConfig = {
  apiToken: process.configs?.CONTENTFUL_API_TOKEN,
  contentfulPreviewApiToken: process.configs?.CONTENTFUL_PREVIEW_API_TOKEN,
  environment: process.configs?.CONTENTFUL_API_ENVIRONMENT,
  spaceId: process.configs?.CONTENTFUL_API_SPACE_ID,
  targetId: process.configs?.TARGET_ENV,
};

// Algolia Enviornment Variables
export const algoliaAPIConfig = {
  algoliaAppId: process.configs?.ALGOLIA_APP_ID,
  algoliaKey: process.configs?.ALGOLIA_SEARCH_API_KEY,
  algoliaAppId_Sandbox: process.configs?.ALGOLIA_APP_ID_SANDBOX,
  algoliaKey_Sandbox: process.configs?.ALGOLIA_SEARCH_API_KEY_SANDBOX,
};
